import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import * as Rest from '../rest/';

import { Service } from './service';

// import { Service } from './service';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
		Rest.RestModule
	],
	providers: [
		Service
	]
})

export class PulseModule {
	constructor(@Optional() @SkipSelf() parentModule: PulseModule) {
		if (parentModule) {
			throw new Error('PulseModule is already loaded. Import it in the AppModule only');
		}
	}

	// static forRoot(config?: {}): ModuleWithProviders {
	// 	return {
	// 		ngModule: PapiModule,
	// 		providers: [
	// 			{provide: ApiModule, useValue: ApiModule }
	// 		]
	// 	};
	// }
}
